import axios from "axios";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { jsonKeyMapping, templateActionEnum } from "../../../Config/Constants";
import FormDataContext from "../../../Contexts/FormData.context";
import TemplateDataContext from "../../../Contexts/TemplateData.context";
import { logger } from "../../../Middleware/Logger";
import { TemplateObject } from "../../../Models/TemplateObject";
// import { processFormRequest } from '../../../Services/TemplateServices'
import ErrorMessage from "../../../Util/ErrorMessage";
import FormBuilder from "../../FormBuilder/FormBuilder";
import ButtonComponent from "../../Shared/ButtonComponent";
import FaqComponent from "../../Shared/FaqComponent";
import PreviewComponent from "../../Shared/PreviewComponent";
import StepBoxLeft from "../../StepContent/StepContentHeader/StepBoxLeft";
import Spinner from "react-bootstrap/Spinner";
import { PathHelper } from "../../../Util/PathHelper";
import { APP_NAVIGATION } from "../../../Util/Constants";

type Props = {
  nextBtn: React.MouseEventHandler<HTMLButtonElement>;
  backBtn: React.MouseEventHandler<HTMLButtonElement>;
  formSubmit: React.MouseEventHandler<HTMLButtonElement>;
  stepDetails: TemplateObject;
  isHideSteps: string[];
  isLoading: boolean;
};

const MainForm = ({ nextBtn, backBtn, formSubmit, stepDetails, isHideSteps, isLoading }: Props) => {
  const { state, dispatch } = useContext(TemplateDataContext);
  const { state: FormState } = useContext(FormDataContext);
  const { formData } = FormState;
  const { templates, activeTemplateSteps } = state;
  let { template, stepName, state: templateState, templateType } = useParams();
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);
  const [hasSubmit, setHasSubmit] = useState(false);

  const stepLength: any = stepDetails;
  const activeStepLength = Object.keys(stepLength).length > 0 ? stepLength.formGroup.length : 0;
  let currentStepNumber = activeTemplateSteps.findIndex((x) => x[jsonKeyMapping.SLUGIFY] === stepName);
  if (activeTemplateSteps.length > 0) {
    stepName = currentStepNumber === -1 ? activeTemplateSteps[0].slugify : stepName;
  }
  const frstStep =
    Object.keys(stepLength).length > 0 && Object.keys(stepLength.formGroup).length === 0
      ? stepLength.stepname.toLowerCase()
      : "";
  const navigate = useNavigate();
  const RedirectPath = PathHelper(APP_NAVIGATION.TEMP);
  // const formSubmit = async () => {
  //     // const cancelToken = axios.CancelToken.source()
  //     // const config = { cancelToken: cancelToken.token }
  //     try {
  //         const submitFormData: TemplateObject = {
  //             template,
  //             templateName: templateType,
  //             state: templateState || '',
  //             formData: {}
  //         }
  //         for (const key in formData) {
  //             if (!key.match('meta-data-')) {
  //                 submitFormData.formData[key] = formData[key]
  //             }
  //         }
  //         // TO DO ::: Redirect
  //         navigate(RedirectPath.next);
  //         // window.location.href = '/app/template/sign-up';
  //         // const { data } = await processFormRequest({ formData: submitFormData, config })
  //         // const { redirectUrl } = data
  //         // window.location.href = redirectUrl
  //     } catch (error) {
  //         if (!axios.isCancel(error)) {
  //             logger.error('🚀 ~ file: useEffect.tsx ~ line 47 ~ changeLayout ~ error', error)
  //             dispatch({ type: templateActionEnum.SET_ERROR, payload: { show: true, message: ErrorMessage.PROCESSING_FORM } })
  //         }
  //     }
  // }

  useEffect(() => {
    const footer = document.querySelector(".temp-footer #minimal-footer");
    const slickSlider = document.querySelector(".fbn");

    if (footer && window.innerWidth < 768) {
      (footer as HTMLElement).style.marginBottom = slickSlider ? "75px" : "0";
    }
    // if that step provide hasNext or previous then go with it
    if (
      stepDetails[jsonKeyMapping.HAS_PREVIOUS] !== undefined ||
      stepDetails[jsonKeyMapping.HAS_NEXT] !== undefined ||
      stepDetails[jsonKeyMapping.HAS_SUBMIT] !== undefined
    ) {
      setHasNext(stepDetails[jsonKeyMapping.HAS_NEXT] || false);
      setHasPrevious(stepDetails[jsonKeyMapping.HAS_PREVIOUS] || false);
      setHasSubmit(stepDetails[jsonKeyMapping.HAS_SUBMIT] || false);
    } else if (templates && template && stepName && activeTemplateSteps.length > 0) {
      // if that step does not provide hasNext and hasPrevious then
      let indexOfThisStep = _.findIndex(activeTemplateSteps, {
        [jsonKeyMapping.SLUGIFY]: stepName,
      });
      indexOfThisStep = indexOfThisStep === -1 ? 0 : indexOfThisStep;
      // if first step then next = true, prev = false , submit = false
      if (indexOfThisStep === 0) {
        setHasNext(true);
        setHasPrevious(false);
        setHasSubmit(false);
      } else if (indexOfThisStep === activeTemplateSteps.length - 1) {
        // if last step then next = false, prev = true , submit = true
        setHasNext(false);
        setHasPrevious(true);
        setHasSubmit(true);
      } else if (indexOfThisStep > 0 && indexOfThisStep < activeTemplateSteps.length) {
        // if step is not last and not first then set next and previous visible
        setHasNext(true);
        setHasPrevious(true);
        setHasSubmit(false);
      }
    }

    return () => {};
  }, [stepDetails, activeTemplateSteps]);
  const step: string = stepName as string;
  return (
    <>
      <div
        className={`${
          stepDetails[jsonKeyMapping.FORM_GROUP] && stepDetails[jsonKeyMapping.FORM_GROUP].length > 0
            ? "col-lg-9"
            : isHideSteps && isHideSteps.includes(step)
            ? "col-lg-12"
            : "col-lg-9"
        }  ${isHideSteps && !isHideSteps.includes(step) && "offsetmargin"} `}
      >
        <div className="px-3 scrollable-div leftsidebar h-75 ">
          {/* TEMPLATE BODY */}
          <div
            // className="card-body bg-grey pt-0 h-75"
            className={
              stepDetails[jsonKeyMapping.FORM_GROUP] && stepDetails[jsonKeyMapping.FORM_GROUP].length > 0
                ? "h-75"
                : "" + " card-body "
            }
          >
            {/* Removed header height so match 40px from the top */}
            {/* <div className="headerheight"></div> */}
            {/* TEMPLATE Header */}
            {stepDetails[jsonKeyMapping.FORM_GROUP] && stepDetails[jsonKeyMapping.FORM_GROUP].length > 0 ? (
              <div className="bg-grey pb-20">
                <p className="font-22 blue-color">{stepDetails[jsonKeyMapping.SLUG]}</p>
              </div>
            ) : (
              <>
                <div className="signup_border description-box ">
                  <div className="col-md-12 signup_border__inner description-box">
                    {frstStep === "start" ? (
                      <>
                        {" "}
                        <div className="blue-color text-center mb-2">
                          <h4 className="fw-bold fs-3">{stepDetails[jsonKeyMapping.SLUG]}</h4>
                          <div className="mt-2 fs-6">
                            {/* {stepDetails[jsonKeyMapping.STEPS_BOX_LEFT] && (

                                                        <img src={process.env.PUBLIC_URL + '/static/images/box-icon-first.png'} className="m-2" />
                                                    )} */}
                            <p className="text-center mb-20">
                              {stepDetails[jsonKeyMapping.DESCRIPTION] ? stepDetails[jsonKeyMapping.DESCRIPTION] : ""}
                            </p>
                            <div className="text-center">
                              <h5 className="fw-600 fs-5">
                                {stepDetails[jsonKeyMapping.TITLE_SECOND]
                                  ? stepDetails[jsonKeyMapping.TITLE_SECOND]
                                  : ""}
                              </h5>
                            </div>
                          </div>
                          <p>
                            {stepDetails[jsonKeyMapping.STEPS_BOX_LEFT] && (
                              <StepBoxLeft subText={stepDetails[jsonKeyMapping.STEPS_BOX_LEFT]} />
                            )}
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className=" row justify-content-md-center info-content-box">
                          <div className="col-md-12 text-center ">
                            <h4 className="fw-bold font-24">{stepDetails[jsonKeyMapping.SLUG]}</h4>
                          </div>
                          <div className="mt-3 font-16 row justify-content-md-around">
                            {stepDetails[jsonKeyMapping.STEPS_BOX_LEFT] && (
                              <div className="col-md-6 col-lg-4">
                                <div className="steps-box">{stepDetails[jsonKeyMapping.STEPS_BOX_LEFT]}</div>
                              </div>
                            )}
                            {stepDetails[jsonKeyMapping.STEPS_BOX_RIGHT] && (
                              <div className="col-md-6 col-lg-4">
                                <div className="steps-box step-box-right">
                                  {stepDetails[jsonKeyMapping.STEPS_BOX_RIGHT]}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="profilerightspace h-100">
              <div className="row main-field align-content: baseline ">
                <div className="col-12 p-0">
                  <div className={`row m-0 ${frstStep === "start" ? "" : "input-field-container"}`}>
                    {/* <div className="col-12 p-0"></div> */}
                    {/* FORM CONTENT */}
                    {stepDetails[jsonKeyMapping.FORM_GROUP] && stepDetails[jsonKeyMapping.FORM_GROUP].length > 0 && (
                      <>
                        <FormBuilder
                          formGroup={stepDetails[jsonKeyMapping.FORM_GROUP]}
                          groups={stepDetails[jsonKeyMapping.FORM_GROUP]}
                          stepDetails={stepDetails}
                        />
                      </>
                    )}
                    {/* ACTION BUTTON FOR MOBILE VIEW */}
                    <div className="pb-20 pt-1 previewmbdispaly">
                      {((stepDetails[jsonKeyMapping.FORM_GROUP] && stepDetails[jsonKeyMapping.FORM_GROUP].length > 0) ||
                        stepDetails[jsonKeyMapping.STEPS_BOX_LEFT]) && <PreviewComponent />}
                      {stepDetails[jsonKeyMapping.FAQ] && stepDetails[jsonKeyMapping.FAQ].length > 0 && (
                        <FaqComponent faqContentList={stepDetails[jsonKeyMapping.FAQ]} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Navigation Button */}
          {isLoading ? (
            <div className="row button-field">
              <div className="col-md-12 d-flex justify-content-center align-items-center mt-4 mb-2rem">
                <Spinner
                  animation="border"
                  className="spinner"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    textAlign: "center",
                    margin: 10,
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="fbn">
              <div className="row button-field prev-nxt-btn-grp">
                <div
                  className={`col-md-12 d-flex justify-content-${
                    (hasNext && hasPrevious) || (hasSubmit && hasPrevious) ? "between" : "center"
                  } align-items-center mt-4 mb-2rem action-btn`}
                >
                  {hasPrevious && (
                    <ButtonComponent
                      buttonProps={{
                        className: "btn btn-white",
                        id: "prevBtn",
                        style: {},
                        text: "BACK",
                      }}
                      clickHandler={backBtn}
                    />
                  )}
                  {hasNext && (
                    <ButtonComponent
                      buttonProps={{
                        className: "btn primary-button btn-orange",
                        id: "nextBtn",
                        style: { marginRight: "1%" },
                        text: "NEXT",
                      }}
                      clickHandler={nextBtn}
                    />
                  )}
                  {hasSubmit && (
                    <ButtonComponent
                      buttonProps={{
                        className: "btn primary-button btn-orange",
                        id: "submitBtn",
                        style: {},
                        text: "SUBMIT",
                      }}
                      clickHandler={formSubmit}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MainForm;
